/* eslint-disable */
export default {
    data: [
        {
            desc: '《营业执照》、《著作权登记证书》',
            secondLevel: '休闲游戏',
            firstLevel: '应用下载'
        },
        {
            desc: '《营业执照》、《著作权登记证书》',
            secondLevel: '社交网络',
            firstLevel: '应用下载'
        },
        {
            desc: '《营业执照》、《著作权登记证书》',
            secondLevel: '娱乐消遣',
            firstLevel: '应用下载'
        },
        {
            desc: '《营业执照》、《著作权登记证书》',
            secondLevel: '生活类',
            firstLevel: '应用下载'
        },
        {
            desc: '《营业执照》、《著作权登记证书》',
            secondLevel: '工具类',
            firstLevel: '应用下载'
        },
        {
            desc: '《营业执照》、《著作权登记证书》',
            secondLevel: '扑克棋牌、捕鱼游戏',
            firstLevel: '应用下载'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '男装、女装、鞋类、配饰',
            firstLevel: '服装服饰'
        },
        {
            desc:
                '《办学许可证》或《事业单位法人证书》或《民办非企业单位登记证书》或《民办学校许可证》或《营业执照》（经营范围含有教育、培训等相关业务）、ICP备案',
            secondLevel: '语言培训',
            firstLevel: '教育培训'
        },
        {
            desc:
                '《办学许可证》或《事业单位法人证书》或《民办非企业单位登记证书》或《民办学校许可证》或《营业执照》（经营范围含有教育、培训等相关业务）、ICP备案',
            secondLevel: '学历教育',
            firstLevel: '教育培训'
        },
        {
            desc:
                '《办学许可证》或《事业单位法人证书》或《民办非企业单位登记证书》或《民办学校许可证》或《营业执照》（经营范围含有教育、培训等相关业务）、ICP备案',
            secondLevel: '职业培训',
            firstLevel: '教育培训'
        },
        {
            desc:
                '《办学许可证》或《事业单位法人证书》或《民办非企业单位登记证书》或《民办学校许可证》或《营业执照》（经营范围含有教育、培训等相关业务）、ICP备案',
            secondLevel: '驾驶证培训',
            firstLevel: '教育培训'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '厨房电器，生活电器',
            firstLevel: '家电'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '餐饮用具、洗护用品',
            firstLevel: '日用百货'
        },
        {
            desc: '《营业执照》、ICP备案 、《中国国家强制性产品认证证书》(3C证书)/《质保证书》/《产品合格证》任意一个',
            secondLevel: '手机、电脑、电子产品',
            firstLevel: 'IT数码'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '箱包',
            firstLevel: '奢侈品'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '手表',
            firstLevel: '奢侈品'
        },
        {
            desc:
                '《营业执照》、ICP备案 、国家珠宝玉石质检中心提供的质量保证书(针对珠宝玉石的产品等级)；进口珠宝需提供中华人民共和国入境货物检验检疫证明。',
            secondLevel: '珠宝钻石',
            firstLevel: '奢侈品'
        },
        {
            desc:
                '《营业执照》、《食品经营许可证》或《餐饮服务许可证》或《食品流通许可证》或《食品生产许可证》任一资质。',
            secondLevel: '餐饮',
            firstLevel: '本地服务'
        },
        {
            desc:
                '《营业执照》，若涉及搬迁（包括搬家，搬场，搬厂，货物搬运）和物流服务的需要《道路运输经营许可证》、ICP备案',
            secondLevel: '家政',
            firstLevel: '本地服务'
        },
        {
            desc: '《营业执照》、《特种行业许可证》或《开锁服务许可证》或公安局备案证明等任一资质',
            secondLevel: '开锁',
            firstLevel: '本地服务'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '休闲娱乐',
            firstLevel: '本地服务'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '生活超市',
            firstLevel: '本地服务'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '商区推广',
            firstLevel: '本地服务'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '婚纱摄影',
            firstLevel: '本地服务'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '情感咨询',
            firstLevel: '本地服务'
        },
        {
            desc: '《营业执照》、ICP备案、《娱乐经营许可证》、《消防检查合格意见书》',
            secondLevel: '游乐园',
            firstLevel: '本地服务'
        },
        {
            desc: '《营业执照》、ICP备案、《公共场所卫生许可证》、《高危险性体育项目经营许可证》',
            secondLevel: '游泳馆',
            firstLevel: '本地服务'
        },
        {
            desc: '《营业执照》、ICP备案、《电影放映经营许可证》、《公共场所卫生许可证》、《消防验收证明》',
            secondLevel: '电影院',
            firstLevel: '本地服务'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '宠物用品',
            firstLevel: '宠物'
        },
        {
            desc: '《营业执照》、ICP备案、《执业兽医证》、《动物诊疗许可证》/《动物防疫合格证》、',
            secondLevel: '宠物医院',
            firstLevel: '宠物'
        },
        {
            desc:
                '如果是房企来投放广告，需提供《《营业执照》》和房地产开发资质等级证书\n如果是投放房地产广告(指房地产项目预售、预租、出售、出租、项目转让等)，需提供:\n1) 《土地使用权证明》、《建设用地规划许可证》、《建设工程规划许可证》或《建筑工程施工许可证》；或者\n2) 《商品房预售许可证》(适用于预售)或者《销售许可证》(适用于现房)。',
            secondLevel: '房产买卖',
            firstLevel: '房地产'
        },
        {
            desc: '《营业执照》、建设主管单位的备案证明文件、《业主委托证明》',
            secondLevel: '房产中介',
            firstLevel: '房地产'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '装修设计',
            firstLevel: '家居建材'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '家装主材',
            firstLevel: '家居建材'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '五金电工',
            firstLevel: '家居建材'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '家居饰品',
            firstLevel: '家居建材'
        },
        {
            desc: '《营业执照》、《证券、期货投资咨询业务许可证》、ICP备案',
            secondLevel: '股票',
            firstLevel: '金融保险'
        },
        {
            desc:
                '《营业执照》、ICP备案、《金融许可证》\n\n若不具备《金融许可证》，需提供《银行资金托管协议》+上市公司投资背景/国资背景 ',
            secondLevel: '投资理财',
            firstLevel: '金融保险'
        },
        {
            desc:
                '《营业执照》、ICP备案、《基金管理资格证书》或《基金代销业务资格证》或需提供基金公司与第三方公司签订的合作协议',
            secondLevel: '基金',
            firstLevel: '金融保险'
        },
        {
            desc: '《营业执照》、ICP备案、《证券、期货投资咨询业务许可证》',
            secondLevel: '证券',
            firstLevel: '金融保险'
        },
        {
            desc: '《营业执照》、ICP备案、《经营期货业务许可证》或《经营外汇业务许可证》',
            secondLevel: '期货外汇（现阶段不接受投放）',
            firstLevel: '金融保险'
        },
        {
            desc: '《营业执照》、ICP备案、《金融许可证》',
            secondLevel: '银行/银行产品',
            firstLevel: '金融保险'
        },
        {
            desc:
                ' 《营业执照》、ICP备案、《保险机构法人许可证》或《经营保险业务许可证》或《经营保险经纪业务许可证》或《经营保险公估业务许可证》或经营保险代理业务许可证》任一资质',
            secondLevel: '保险',
            firstLevel: '金融保险'
        },
        {
            desc: '《营业执照》、ICP备案、《贵金属交易会员证书》或经国务院或国务院金融管理部门批准的贵金属交易平台',
            secondLevel: '贵金属(现阶段不接受投放)',
            firstLevel: '金融保险'
        },
        {
            desc: '《营业执照》、ICP备案、国家商务部颁发的《典当经营许可证》或公安机关颁发的《特种行业许可证》',
            secondLevel: '典当',
            firstLevel: '金融保险'
        },
        {
            desc: '《营业执照》、ICP备案、融资性担保机构经营许可证',
            secondLevel: '担保',
            firstLevel: '金融保险'
        },
        {
            desc: '《营业执照》、ICP备案、小额贷款资质',
            secondLevel: '网贷平台',
            firstLevel: '金融保险'
        },
        {
            desc: '《营业执照》、ICP备案、《金融许可证》',
            secondLevel: '信托',
            firstLevel: '金融保险'
        },
        {
            desc:
                '1.金融资产管理公司需要提交《金融许可证》或《金融机构法人许可证》或《金融机构营业许可证》\n2.保险资产管理公司需要提交《经营保险资产管理业务许可证》\n3.省级资产管理公司提供省级政府设立批文',
            secondLevel: '资产管理',
            firstLevel: '金融保险'
        },
        {
            desc:
                '1.国务院、国务院金融办、省级人民政府等有权机关批准该交易平台成立的证明文件\n2.提供《大宗交易市场会员证书》',
            secondLevel: '大宗商品交易/现货',
            firstLevel: '金融保险'
        },
        {
            desc: '《营业执照》、ICP备案、《金融许可证》',
            secondLevel: '汽车金融',
            firstLevel: '金融保险'
        },
        {
            desc:
                '1.个人征信业务：营业执照、icp备案、《个人征信业务经营许可证》\n2.企业征信业务：营业执照、icp备案、提供所在地省级国务院征信监督管理部门（即中国人民银行）派出机构出具的备案证明',
            secondLevel: '征信机构',
            firstLevel: '金融保险'
        },
        {
            desc:
                '1.企业名称必须含有“商业保理”字样\n2.企业应当是天津市、上海市、深圳市、广州市、重庆市、江苏省的企业\n3.提交主管单位同意设立商业保理公司的批文',
            secondLevel: '商业保理',
            firstLevel: '金融保险'
        },
        {
            desc: '《营业执照》、ICP备案 、《食品生产许可证》、《保健食品广告批文》或《国产/进口保健食品批准证书》',
            secondLevel: '减肥瘦身',
            firstLevel: '美容化妆'
        },
        {
            desc:
                '《营业执照》、ICP备案、《化妆品生产许可证》。如果是进口化妆品，需提供中华人民共和国进口化妆品备案凭证+近两年内中华人民共和国海关进口货物报关单扫描件。',
            secondLevel: '功能化妆品',
            firstLevel: '美容化妆'
        },
        {
            desc: '《营业执照》、ICP备案 、《食品生产许可证》、《保健食品广告批文》或《国产/进口保健食品批准证书》',
            secondLevel: '丰胸',
            firstLevel: '美容化妆'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '育儿网站',
            firstLevel: '母婴儿童'
        },
        {
            desc:
                '1、宝宝食品销售商需提供: 《食品经营许可证》(经营项目含婴幼儿配方乳粉或其他婴幼儿配方食品)或《食品生产许可证》或《食品流通许可证》或《食品卫生许可证》任一资质、ICP备案。进口宝宝食品食品还需补充《出入境检验检疫合格证明》\n2、涉及婴幼儿奶粉相关的宝宝食品:\n国产: 需提供生产商的《食品生产许可证》，ICP备案、且生产许可证附页须注明获得许可生产的婴儿配方乳粉、较大婴儿配方乳粉和幼儿配方乳粉的具体品种明细。\n进口: 《出入境检验检疫卫生证书》',
            secondLevel: '宝宝食品',
            firstLevel: '母婴儿童'
        },
        {
            desc:
                '车辆租赁公司：《营业执照》、ICP备案、《道路运输经营许可证》、《汽车租赁经营许可证》、汽车租赁经营备案证明等任一资质。',
            secondLevel: '车辆交易',
            firstLevel: '汽车'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '汽车用品',
            firstLevel: '汽车'
        },
        {
            desc: '《营业执照》、ICP备案、《机动车维修经营许可证》',
            secondLevel: '汽车服务',
            firstLevel: '汽车'
        },
        {
            desc:
                '1、二手车拍卖机构: 《营业执照》、ICP备案、《拍卖经营批准证书》；\n2、二手车鉴定评估机构: 《营业执照》、ICP备案、《二手车鉴定评估机构核证书》',
            secondLevel: '二手车',
            firstLevel: '汽车'
        },
        {
            desc: '《营业执照》、ICP备案、《自费出国留学中介机构资格认定书》',
            secondLevel: '留学中介',
            firstLevel: '商务服务'
        },
        {
            desc: '《营业执照》、ICP备案、《因私出入境中介机构经营许可证》',
            secondLevel: '移民中介',
            firstLevel: '商务服务'
        },
        {
            desc: ' 《营业执照》、ICP备案、 《人力资源服务许可证》',
            secondLevel: '招聘',
            firstLevel: '商务服务'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '策划咨询/广告',
            firstLevel: '商务服务'
        },
        {
            desc: '《营业执照》、ICP备案、《会计师事务所执业证书》、《税务师事务所执业证书》',
            secondLevel: '会计税务',
            firstLevel: '商务服务'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '会展',
            firstLevel: '商务服务'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '翻译',
            firstLevel: '商务服务'
        },
        {
            desc: '《营业执照》、ICP备案、《中华人民共和国物业服务资质证书》',
            secondLevel: '物业公司 ',
            firstLevel: '商务服务'
        },
        {
            desc: '《营业执照》、ICP备案、《拍卖经营许可证》',
            secondLevel: '拍卖',
            firstLevel: '商务服务'
        },
        {
            desc: '《营业执照》、ICP备案、《司法鉴定机构执业许可证》',
            secondLevel: '司法鉴定',
            firstLevel: '商务服务'
        },
        {
            desc:
                '《营业执照》、ICP备案   、《食品经营许可证》或《餐饮服务许可证》或《食品流通许可证》或《食品生产许可证》任一资质。\n\n进口食品补充：《商品出入境检验检疫合格证明》',
            secondLevel: '食品饮料',
            firstLevel: '食品饮料'
        },
        {
            desc:
                '《营业执照》、ICP备案  、《食品经营许可证》或《食品卫生许可证》或《食品流通许可证》或《食品生产许可证》(含酒类) 或《酒类生产许可证》或《全国工业产品生产许可证》(含酒类)或《酒类批发许可证》、《酒类零售许可证》之一；经国家规定或认可的省辖市以上食品质量检验机构出具的该就符合质量标准的检验证明；发布境外生产的酒类商品广告的，应提供以下其中一种证明:《进口食品卫生证书》、《进口食品标签审核证书》或其他进口检验检疫证明等',
            secondLevel: '酒水',
            firstLevel: '食品饮料'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '体育用品',
            firstLevel: '体育用品'
        },
        {
            desc:
                '《营业执照》、《出版物经营许可证》或《互联网出版许可证》或《网络文化经营许可证》或《网络出版服务许可证》',
            secondLevel: '书籍杂志',
            firstLevel: '文化娱乐'
        },
        {
            desc: '《营业执照》、《网络文化经营许可证》、《著作权登记证书》',
            secondLevel: '在线视听',
            firstLevel: '文化娱乐'
        },
        {
            desc: '《营业执照》、《网络文化经营许可证》或《互联网出版许可证》或《网络出版服务许可证》',
            secondLevel: '在线阅读',
            firstLevel: '文化娱乐'
        },
        {
            desc:
                '《出版物经营许可证》或《互联网出版许可证》或《网络文化经营许可证》或《网络出版服务许可证》或《广播电视节目制作经营许可证》',
            secondLevel: '影视音像',
            firstLevel: '文化娱乐'
        },
        {
            desc:
                '《营业执照》、ICP备案 （ 可等额兑换人民币的纸钞、硬币类收藏品以及曾流通或正在流通的人民币收藏品中国人民银行批准的发行证书。）（贵重金属、稀有矿石（玉宝石等）收藏品：正规鉴定机构提供的鉴定证书；）',
            secondLevel: '爱好收藏',
            firstLevel: '文化娱乐'
        },
        {
            desc: '《营业执照》、ICP备案、《医疗机构执业许可证》、《医疗广告审查证明》、《医疗广告成品样件表》',
            secondLevel: '医疗机构（医美、口腔外的医院暂不开户投放）',
            firstLevel: '医疗'
        },
        {
            desc:
                '[销售商] 《营业执照》、ICP备案\n1、国产药品: 《药品经营许可证》；\n2、进口药品:按照国家有关规定提供相关证明文件。相关证明如:进口药批准文件或海关通关单或口岸药检所检验报告等。如果含有多个药品，需提供至少3个药品的资料。\n\n[经营模式] 《营业执照》、ICP备案\n1、通过互联网提供药品（含医疗器械）信息：《互联网药品信息服务资格证书》；\n2、通过互联网提供药品（含医疗器械）交易：《互联网药品交易服务机构资格证》',
            secondLevel: '药品交易',
            firstLevel: '医疗'
        },
        {
            desc: '营业执照、ICP备案、《互联网药品信息服务资格证书》',
            secondLevel: '药品信息',
            firstLevel: '医疗'
        },
        {
            desc:
                '[生产商] 《营业执照》、ICP备案\n1、《药品生产许可证》或《药品经营许可证》；\n2、《药品GMP证书》；\n3、如果广告内容含有药品，需要提供该药品的《药品广告审查表》，如果广告内容里含有多种药品，提供其中至少3个药品的审查表\n4、如果通过互联网提供药品（含医疗器械）信息：《互联网药品信息服务资格证书》（药商的官网则无需提供本项；\n5、如果通过互联网提供药品（含医疗器械）交易：需提供《互联网药品交易服务机构资格证》。',
            secondLevel: '药品生产研发',
            firstLevel: '医疗'
        },
        {
            desc:
                '1、《营业执照》、ICP备案    2、《医疗器械生产企业许可证》、《医疗器械经营企业许可证》；如果广告中重点推广某个医疗器械，需要提供该医疗器械的《医疗器械广告审查表》。',
            secondLevel: '医疗器械',
            firstLevel: '医疗'
        },
        {
            desc: '《营业执照》、ICP备案、《保健用品许可证》',
            secondLevel: '保健用品',
            firstLevel: '医疗'
        },
        {
            desc:
                '《营业执照》、ICP备案、《保健食品广告批文》、《国产/进口保健食品批准证书》\n生产商: 《食品卫生许可证》或《食品生产许可证》或《食品经营许可证》任一资质；\n销售商(国产/进口) :《产品检验合格证》',
            secondLevel: '保健食品',
            firstLevel: '医疗'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '电商平台、教育培训、餐饮服务、商务服务、美容化妆、医药保健等',
            firstLevel: '招商加盟'
        },
        {
            desc: '《司法鉴定机构执业许可证》、ICP备案',
            secondLevel: '司法鉴定',
            firstLevel: '法律服务'
        },
        {
            desc: '《律师事务所执业许可证》、ICP备案',
            secondLevel: '律师事务所',
            firstLevel: '法律服务'
        },
        {
            desc: '《公证机构执业证》、ICP备案',
            secondLevel: '公证',
            firstLevel: '法律服务'
        },
        {
            desc:
                '《营业执照》、ICP备案、如涉及危险化学品，需出具《危险化学品安全生产许可证》或《危险化学品经营许可证》。',
            secondLevel: '化工和材料',
            firstLevel: '工农业'
        },
        {
            desc:
                '如果兽药网站是个电商平台，需提供:《营业执照》、ICP备案；   \n\n如果兽药网站为兽药生产以及销售商，需提供:\n1，《兽药生产/经营许可证》或批准文号文件；\n2，兽药广告审查表\n3，涉及动物疾病诊疗的需提供《动物诊疗许可证》',
            secondLevel: '兽医兽药',
            firstLevel: '工农业'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '机械零件',
            firstLevel: '工农业'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '农林牧渔',
            firstLevel: '工农业'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '电商平台',
            firstLevel: '互联网服务'
        },
        {
            desc: '《营业执照》、ICP备案、《支付业务许可证》',
            secondLevel: '第三方支付平台',
            firstLevel: '互联网服务'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '门户社区',
            firstLevel: '互联网服务'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '分类信息',
            firstLevel: '互联网服务'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '运营商服务',
            firstLevel: '互联网服务'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '——',
            firstLevel: '电商购物'
        },
        {
            desc: '《营业执照》、ICP备案、《食品经营许可证》或《食品流通许可证》',
            secondLevel: '茶/饮料',
            firstLevel: '食品饮料类'
        },
        {
            desc: '《营业执照》、ICP备案、《食品经营许可证》或《食品流通许可证》',
            secondLevel: '零食',
            firstLevel: '食品饮料类'
        },
        {
            desc: '《营业执照》、ICP备案、《食品经营许可证》或《食品流通许可证》',
            secondLevel: '有机食品',
            firstLevel: '食品饮料类'
        },
        {
            desc: '《营业执照》、ICP备案、《食品经营许可证》或《食品流通许可证》',
            secondLevel: '粮油米面调味品',
            firstLevel: '食品饮料类'
        },
        {
            desc: '《营业执照》、ICP备案、《食品经营许可证》或《食品流通许可证》',
            secondLevel: '酒水',
            firstLevel: '食品饮料类'
        },
        {
            desc: '《营业执照》、ICP备案、《食品经营许可证》或《食品流通许可证》',
            secondLevel: '进口食品',
            firstLevel: '食品饮料类'
        },
        {
            desc: '《营业执照》、ICP备案、《旅行社业务经营许可证》',
            secondLevel: '旅游机构/旅游平台',
            firstLevel: '旅游住宿出行'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '旅游景点',
            firstLevel: '旅游住宿出行'
        },
        {
            desc:
                '《营业执照》、ICP备案、《增值电信业务经营许可证》/《基础电信业务经营许可证》/《因特网接入服务业务经营许可证》',
            secondLevel: '通信运营商',
            firstLevel: '通信服务设备'
        },
        {
            desc: '《营业执照》、ICP备案、《增值电信业务经营许可证》',
            secondLevel: '无线增值',
            firstLevel: '通信服务设备'
        },
        {
            desc: '《营业执照》、ICP备案、《中国国家强制性产品认证证书》（3C证书）',
            secondLevel: '通信设备',
            firstLevel: '通信服务设备'
        },
        {
            desc: '《营业执照》、ICP备案、《快递业务经营许可证》',
            secondLevel: '快递',
            firstLevel: '物流快递'
        },
        {
            desc: '《营业执照》、ICP备案、《快递业务经营许可证》或《道路运输经营许可证》',
            secondLevel: '物流',
            firstLevel: '物流快递'
        },
        {
            desc: '《营业执照》、ICP备案、《出版物经营许可证》',
            secondLevel: '纸质媒体',
            firstLevel: '新闻传媒'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '广播电视',
            firstLevel: '新闻传媒'
        },
        {
            desc: '《营业执照》、ICP备案、《网络文化经营许可证》',
            secondLevel: '新媒体',
            firstLevel: '新闻传媒'
        },
        {
            desc: '《营业执照》、ICP备案',
            secondLevel: '其他',
            firstLevel: '其他'
        }
    ]
};
